import { Component, OnInit, AfterViewInit, AfterViewChecked, AfterContentInit } from '@angular/core';
import { UsuarioService, GralUsrDto } from '../contabilidad/catalogo/usuario/usuario.service';
import { LoginService } from '../contabilidad/login/login.service';
import { PaginadorService } from '../contabilidad/paginador/paginador.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
declare var $: any;
//Metadata
export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype: string;
  // icon: string;
  children?: ChildrenItems[];
}

export interface ChildrenItems {
  path: string;
  title: string;
  ab: string;
  type?: string;
  role?: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [
  /* =======================
   * DASHBOARD
   * ======================= */
  {
    path: '/dashboard',
    title: 'Dashboard',
    type: 'link',
    icontype: 'pe-7s-graph'
  },

  /* =======================
   * PROCESOS CONTABLES
   * ======================= */
  {
    path: '/contabilidad/proceso',
    title: 'Procesos_Contables',
    type: 'sub',
    icontype: 'pe-7s-way',
    children: [
      { path: 'ctb-pol', title: 'Pólizas', ab: 'POL', role: '' },
      { path: 'sat', title: 'Contabilidad Electronica', ab: 'CE', role: '' },
    ]
  },

  /* =======================
   * DOCUMENTOS
   * ======================= */
  {
    path: '/contabilidad/documentos',
    title: 'Documentos',
    type: 'sub',
    icontype: 'pe-7s-way',
    children: [
      { path: 'add-doc', title: 'Suite CFDI', ab: 'ADC', role: 'ROLE_CTB_ADD_DOC' },
      { path: 'ctb-diot', title: 'PREDIOT', ab: 'PRE', role: 'ROLE_CTB_DIOT' }
    ]
  },

  /* =======================
   * CATÁLOGOS
   * ======================= */
  {
    path: '/contabilidad/catalogo',
    title: 'Catalogos',
    type: 'sub',
    icontype: 'pe-7s-note2',
    children: [
      { path: 'ctb-cta', title: 'Cuentas Contables', ab: 'CTA', role: 'ROLE_CTB_CUENTAS_CONTABLES' },
      { path: 'ctb-cc', title: 'Centros de Costo', ab: 'CC', role: 'ROLE_CTB_CENTRO_COSTO' },
      //{ path: 'valuacion-moneda-extranjera', title: 'Valuación Moneda Extranjera', ab: 'VME', role: 'ROLE_CTB_VAL_MON_EXT' },
      { path: 'gral-mon', title: 'Monedas', ab: 'MON', role: 'ROLE_GRAL_MON' },
      { path: 'ctb-tpol', title: 'Tipos de Póliza', ab: 'TPO', role: '' }
    ]
  },

  /* =======================
   * CONFIGURACIÓN
   * ======================= */
  {
    path: '/contabilidad/catalogo',
    title: 'Configuración',
    type: 'sub',
    icontype: 'pe-7s-notebook',
    children: [
      { path: 'ctb-conf', title: 'Empresa', ab: 'EMP', role: 'ROLE_CTB_CONFIGURACION_EMPRESA' },
      { path: 'usuario', title: 'Usuario', ab: 'USR', role: 'ROLE_GRAL_USER' 
        
      },
      { path: 'ctb-csd-conf', title: 'CSD', ab: 'CSD', role: 'ROLE_CARGA_CSD' }
    ]
  },

  /* =======================
   * REPORTES - CENTRO DE COSTOS
   * ======================= */
  {
    path: '/contabilidad/reporte',
    title: 'Centro_de_costos',
    type: 'sub',
    icontype: 'pe-7s-note2',
    children: [
      { path: 'estado-resultados-cc', title: 'Rentabilidad por Centro de Costos', ab: 'REN', role: 'ROLE_REP_CTB_REN_CC' },
      { path: 'gastos-sucursal', title: 'Gastos por Sucursal', ab: 'GS', role: 'ROLE_REP_CTB_GAS_SUC' }
    ]
  },

  /* =======================
   * REPORTES CONTABLES
   * ======================= */
 /** {
    path: '/contabilidad/reporte',
    title: 'Reportes_Contables',
    type: 'sub',
    icontype: 'pe-7s-notebook',
    children: [
      { path: 'balanza-comprobacion', title: 'Balanza de Comprobación', ab: 'BCO', role: 'ROLE_REP_CTB_BAL_COM' },
      { path: 'balance-general', title: 'Balance General', ab: 'BGE', role: 'ROLE_REP_CTB_BAL_GEN' },
      { path: 'estado-resultados', title: 'Estado de Resultados', ab: 'ERE', role: 'ROLE_REP_CTB_EDO_RES' }
    ]
  },*/ /* =======================
   * REPORTES CONTABLES DINAMICOS
   * ======================= */
  {
    path: '/contabilidad/reporte',
    title: 'Suite_Contable',
    type: 'sub',
    icontype: 'pe-7s-notebook',
    children: [
      { path: 'ctb-cta', title: 'Arbol de Cuentas', ab: 'CTA', role: 'ROLE_REP_CTB_CTA' },
      { path: 'rep-mov', title: 'Auxiliar de Movimientos', ab: 'RM', role: 'ROLE_REP_CTB_AUX_MOV' },
      { path: 'balanza-comprobacion-din', title: 'Balanza de Comprobación', ab: 'BCO', role: 'ROLE_REP_CTB_BAL_COM' },
      { path: 'balance-general-din', title: 'Balance General', ab: 'BGE', role: 'ROLE_REP_CTB_BAL_GEN' },
      { path: 'estado-resultados-din', title: 'Estado de Resultados', ab: 'ERE', role: 'ROLE_REP_CTB_EDO_RES' },
      { path: 'punto-equilibrio', title: 'Punto de Equilibrio', ab: 'PE', role: '' }
    ]
  },

  /* =======================
   * REPORTES FISCALES
   * ======================= */
  {
    path: '/contabilidad/reporte_fis',
    title: 'Control_de_IVA',
    type: 'sub',
    icontype: 'pe-7s-notebook',
    children: [
      { path: 'iva-pag-clie', title: 'IVA Cobrado a Cliente', ab: 'IPC', role: '' },
      { path: 'iva-pag-prov', title: 'IVA Pagado a Proveedor', ab: 'IPP', role: '' }
    ]
  }
];

@Component({
  moduleId: module.id,
  selector: 'sidebar-cmp',
  templateUrl: 'sidebar.component.html',
})

export class SidebarComponent {
  user: GralUsrDto = new GralUsrDto();
  public menuItems: any[];
  periodo_vigente: number;
  isNotMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }
  constructor(private paginadorService: PaginadorService, private service: LoginService,
    private userService: UsuarioService, private router: Router,
    private activatedRoute: ActivatedRoute) {
    this.cargarUsuario();
  }

  borrarBusquedaCatalogo(){
    this.paginadorService.borrarBusquedas();
  }
  cargarUsuario() {
    this.user.id = this.service.usuario.id;
    this.user.username = this.service.usuario.username;
    this.user.email = this.service.usuario.email;
    this.user.gralUsrPictureDto.picture = this.service.usuario.picture;

  }
  logout() {
    this.service.logout();
    this.router.navigate(['/pages/login']);

  }
  ngOnInit() {
    this.periodo_vigente = parseInt(localStorage.getItem('periodo_seleccionado'));
    var isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;
    this.menuItems = ROUTES.filter(menuItem => menuItem);

    isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;

    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      $('.sidebar .sidebar-wrapper, .main-panel').perfectScrollbar();
      $('html').addClass('perfect-scrollbar-on');
    } else {
      $('html').addClass('perfect-scrollbar-off');
    }
  }
  ngAfterViewInit() {
    var $sidebarParent = $('.sidebar .nav > li.active .collapse li.active > a').parent().parent().parent();

    var collapseId = $sidebarParent.siblings('a').attr("href");

    $(collapseId).collapse("show");
  }
}
